/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Henrique Limas */
/** @author Ian Hofmann-Hicks */

var getPropOr = require('./getPropOr')

module.exports =
  getPropOr.origFn('propOr')
